import { render, staticRenderFns } from "./tenant-edit.vue?vue&type=template&id=654fa7aa&scoped=true&"
import script from "./tenant-edit.vue?vue&type=script&lang=tsx&"
export * from "./tenant-edit.vue?vue&type=script&lang=tsx&"
import style0 from "./tenant-edit.vue?vue&type=style&index=0&id=654fa7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654fa7aa",
  null
  
)

export default component.exports